import type React from 'react';

import { useTemplateResponseActions } from '../../../../hooks/settings/template-response/useTemplateResponseActions';
import { TemplateResponseDataModal } from './TemplateResponseDataModal';

export const CreateTemplateResponseModal: React.FC = () => {
  const { createTemplateResponse } = useTemplateResponseActions();
  return <TemplateResponseDataModal onSubmit={createTemplateResponse} />;
};

export default CreateTemplateResponseModal;
